
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { applicationUrls } from 'src/app/shared/application-constants/application-urls.const';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import { Division } from 'src/app/shared/models/common.model';
import { FinancialDetails } from '../models/FinancialDetails.model';
import { Furniture } from '../models/furniture.model';
import { StpManagement } from '../models/stp-management.model';
import { StpOccupationTool } from '../models/stp-occupation-tool.model';
import { StpTrainer } from '../models/stp-trainer.model';
import { STPAppStatus } from '../models/stp_app_status.model';
import { STPAppType } from '../models/stp_app_type.model';
import { STPLocation } from '../models/stp_location.model';
import { STPMain } from '../models/stp_main.model';
import { STPOwnershipType } from '../models/stp_ownership_type.model';
import { STPOwnerType } from './../models/stp_owner_type.model';
import { STPType } from './../models/stp_type.model';
import { SYSCountry } from './../models/sys_country.model';
import { StpRegistrationService } from './stp-registration.service';
import { RequestData } from '../models/stp_onlinePayment.model';
import { STpNameUpdateRequest } from '../DTO/stp-name-update-request.model';
import { StpFilteringRequestData } from '../models/stp_filteringRequest.model';
import { StpMainSearchingDto } from '../DTO/stp_main_searching_dto.model';
import { TempApproveRejectStpUserDto } from '../DTO/temp-approve-reject-stp-user-dto';
import { StpOrganizationAddressUpdateRequest } from '../DTO/stp-organization-address-update-request.model';
import { StpMain } from '../../course-accreditation/models/stp-main.model';
import { Ministry } from '../models/ministry.model';
import { Agency } from '../models/agency.model';
import { InspectorOfficer1 } from '../../course-accreditation/models/inspector-officer-1.model';
import { InspectionOfficer } from '../../course-accreditation/models/inspectionOfficer';
import { PaymentDto } from 'src/app/shared/models/dto/payment-dto.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StpRegistrationStorageService {


  constructor(
    private httpClient: HttpClient,
    private stpRegistrationService: StpRegistrationService
  ) { }

  // #region MANAGEMENT_AND_SUPPORT_STAFF
  readStpManagement(): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.management.read}`)
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.setStpManagements(response.data);
            return response.data;
          }
        })
      );
  }
  //#region Nobin

  readStpType(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.basicProfile.readStpType}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((stpType: STPType[]) => {
          this.stpRegistrationService.setSTPTypes(stpType);
        })
      );
  }

  readStpOwnerType(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.basicProfile.readStpOwnerType}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((stpOwnerType: STPOwnerType[]) => {
          this.stpRegistrationService.setSTPOwnerTypes(stpOwnerType);
        })
      );
  }

  deleteStpManagement(id: number): Observable<ServerResponse> {
    return this.httpClient
      .delete<ServerResponse>(`${applicationUrls.management.delete}` + id)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((updatedStpManagement) => {
          this.stpRegistrationService.deleteStpManagement(id);
        })
      );
  }

  readStpPosition(): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(`${applicationUrls}`).pipe(
      tap((response) => {
        if (response.data) {
          this.stpRegistrationService.setStpManagementPositions(response.data);
        }
      })
    );
  }
  // #region Occupation specific tools region
  readStpOwnerShipType(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpOwnerShipType}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((stpOwnerType: STPOwnershipType[]) => {
          this.stpRegistrationService.setSTPOwnerShipTypes(stpOwnerType);
        })
      );
  }

  readStpMinistriesByOwnerShipId(ownershipId: number): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpMinistryByOwnershipId}` +
        ownershipId
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }

  readStpAgencyByMinistryId(ministrypId: number): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpAgencyByMinistryId}` +
        `ministry/${ministrypId}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }

  readStpLocations(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.basicProfile.readStpLocation}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((stpLocation: STPLocation[]) => {
          this.stpRegistrationService.setSTPLocations(stpLocation);
        })
      );
  }

  readStpCountries(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.basicProfile.readStpCountry}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((ghat: SYSCountry[]) => {
          this.stpRegistrationService.setSTPCountries(ghat);
        })
      );
  }


  readStpDivisionsBYCountryID(countryId: number): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpDivision}${countryId}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((division: Division[]) => {
          this.stpRegistrationService.setSTPDivisions(division);
        })
      );
  }



  readStpDistricts(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpDistrict}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }



  readStpDistrictsByDivisionId(divisionId: number): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpDistrictByDivisionId}` +
        `districts/${divisionId}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }

  readStpUpazillasByDistrictId(districtId: number): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpUpazilla}district/${districtId}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }

  readStpPostOfficesByUpazilaId(upazilaId: number): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpPostOfficeByUpazila}upazila/${upazilaId}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }
  readStpUserName(): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.basicProfile.stpUserName}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }

  readStpAppStatuses(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.basicProfile.readStpAppStatus}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((stpAppStatus: STPAppStatus[]) => {
          this.stpRegistrationService.setSTPAppStatuses(stpAppStatus);
        })
      );
  }

  readStpAppTypes(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.basicProfile.readStpAppTypes}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((stpAppType: STPAppType[]) => {
          this.stpRegistrationService.setSTPAppTypes(stpAppType);
        })
      );
  }

  createBasicProfile(stpMain: STPMain): Observable<any> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.basicProfile.createBasicProfile}`,
        stpMain
      )
      .pipe(
        tap((res) => {
          if (res.data) {
            this.stpRegistrationService.addBasicProfile(res.data);
          }
        })
      );
  }

  updateBasicProfile(stpMain: STPMain): Observable<any> {
    return this.httpClient
      .put<ServerResponse>(
        `${applicationUrls.basicProfile.updateBasicProfile}`,
        stpMain
      )
      .pipe(
        tap((res) => {
          if (res.data) {
            this.stpRegistrationService.updateBasicProfile(res.data);
          }
        })
      );
  }

  updateAdminBasicProfile(stpMain: STPMain, stpMainId: number): Observable<any> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.basicProfile.updateAdminBasicProfile}` + stpMainId,
      stpMain
    );
  }

  //#endregion nobin

  //#region OCCUPATION_SPECIFIC_TRAINER Parvez

  readStpTrainer(): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.stpTrainer.read}`)
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.setStpTrainers(response.data);
          }
        })
      );
  }

  readStpTrainerById(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.stpTrainer.readById}` + id
    );
  }

  createStpTrainer(stpTrainer: StpTrainer): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(`${applicationUrls.stpTrainer.create}`, stpTrainer)
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.addStpTrainer(response.data);
          }
        })
      );
  }

  createAdminStpTrainer(
    stpTrainer: StpTrainer,
    stpMainId: number
  ): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.stpTrainer.adminCreate}` + stpMainId,
      stpTrainer
    );
  }

  deleteStpTrainer(id: number): Observable<ServerResponse> {
    return this.httpClient
      .delete<ServerResponse>(`${applicationUrls.stpTrainer.delete}` + id)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((updatedStpTrainer) => {
          this.stpRegistrationService.deleteStpTrainer(id);
        })
      );
  }

  updateStpTrainer(
    stpTrainer: StpTrainer,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient
      .put<ServerResponse>(
        `${applicationUrls.stpTrainer.update}` + id,
        stpTrainer
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.upatedStpTrainer(
              response.data,
              response.data.id
            );
          }
        })
      );
  }

  updateAdminStpTrainer(
    stpTrainer: StpTrainer,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.stpTrainer.adminUpdate}` + id,
      stpTrainer
    );
  }

  // readStpTrainers(): Observable<StpTrainer | StpTrainer[]> {
  //   return this.httpClient
  //     .get<ServerResponse>(`${applicationUrls.stpTrainer.read}`)
  //     .pipe(
  //       map((serverResponse: ServerResponse) => {
  //         if (!serverResponse.data) {
  //           return [];
  //         }
  //         return serverResponse.data.sort((a: StpTrainer, b: StpTrainer) =>
  //           a.stpTrainerOccupation.occupationName <
  //           b.stpTrainerOccupation.occupationName
  //             ? -1
  //             : 1
  //         );
  //       }),
  //       tap((stpTrainers: StpTrainer[]) => {
  //         this.stpRegistrationService.setStpTrainers(stpTrainers);
  //       })
  //     );
  // }

  // readStpOccupation(): Observable<ServerResponse> {
  //   return this.httpClient
  //     .get<ServerResponse>(`${applicationUrls.stpTrainer.readOccupation}`)
  //     .pipe(
  //       tap((response) => {
  //         if (response.data) {
  //           this.stpRegistrationService.setStpTrainerOccupations(response.data);
  //         }
  //       })
  //     );
  // }
  // #endregion Occupation specific tools region

  // readTrainerOccupationList(): Observable<any[]> {
  //   return this.httpClient
  //     .get<ServerResponse>(
  //       `${applicationUrls.furniture.readTrainerOccupations}`
  //     )
  //     .pipe(
  //       map((serverResponse: ServerResponse) => {
  //         return serverResponse.data;
  //       }),
  //       tap((trainerOccupation: any[]) => {
  //         this.stpRegistrationService.setTrainerOccupations(trainerOccupation);
  //       })
  //     );
  // }

  //#endregion OCCUPATION_SPECIFIC_TRAINER

  //#region Irfan

  readFurnitureById(id: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.furniture.readFurnitureById + id}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((furniture: any) => { })
      );
  }

  readStpFurniture(): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.furniture.read}`)
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.setFurniture(response.data);
          }
        })
      );
  }

  createFurniture(furniture: Furniture): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(`${applicationUrls.furniture.create}`, furniture)
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.addFurniture(response.data);
          }
        })
      );
  }

  createAdminFurniture(
    furniture: Furniture,
    stpMainId: number
  ): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.furniture.adminCreate}` + stpMainId,
      furniture
    );
  }

  deleteFurniture(id: number): Observable<ServerResponse> {
    return this.httpClient
      .delete<ServerResponse>(`${applicationUrls.furniture.delete}` + id)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((updatedStpTrainer) => {
          this.stpRegistrationService.deleteFurniture(id);
        })
      );
  }

  updateFurniture(
    furniture: Furniture,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient
      .put<ServerResponse>(
        `${applicationUrls.furniture.update}` + id,
        furniture
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.upatedFurniture(
              response.data,
              response.data.id
            );
          }
        })
      );
  }

  updateAdminFurniture(
    furniture: Furniture,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.furniture.adminUpdate}` + id,
      furniture
    );
  }

  //#endregion Irfan

  // #region Tareque

  createStpInfrastructure(physicalInfrastructureRequest: any): Observable<any> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.infrastructure.create}`,
        physicalInfrastructureRequest
      )
      .pipe(
        tap((res) => {
          if (res.data) {
            this.stpRegistrationService.addInfrastructure(res.data);
          }
        })
      );
  }

  updateStpInfrastructure(physicalInfrastructureRequest: any): Observable<any> {
    return this.httpClient
      .put<ServerResponse>(
        `${applicationUrls.infrastructure.update}`,
        physicalInfrastructureRequest
      )
      .pipe(
        tap((res) => {
          if (res.data) {
            this.stpRegistrationService.updateInfrastructure(res.data);
          }
        })
      );
  }

  createAdminStpInfrastructure(
    physicalInfrastructureRequest: any,
    stpMainId: number
  ): Observable<any> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.infrastructure.adminCreate}` + stpMainId,
      physicalInfrastructureRequest
    );
  }

  updateAdminStpInfrastructure(
    physicalInfrastructureRequest: any,
    stpMainId: number
  ): Observable<any> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.infrastructure.adminUpdate}` + stpMainId,
      physicalInfrastructureRequest
    );
  }

  readOwnershipStatusList(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.infrastructure.readOwnershipStatus}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((ownershipStatus: any[]) => {
          this.stpRegistrationService.setOwnershipStatus(ownershipStatus);
        })
      );
  }

  readConstructionTypeList(): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.infrastructure.readConstructionType}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((constructionType: any[]) => {
          this.stpRegistrationService.setConstructionType(constructionType);
        })
      );
  }
  // #endregion Tareque

  //#region Emon
  // createPayment(payment: Payment): Observable<ServerResponse> {
  //   return this.httpClient
  //     .post<ServerResponse>(`${applicationUrls.payment.create}`, payment)
  //     .pipe(
  //       map((serverResponse: ServerResponse) => {
  //         return serverResponse;
  //       })
  //     );
  // }

  //#endregion Emon

  //#region Financial Details

  createFinancialDetails(
    financialDetails: FinancialDetails
  ): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        applicationUrls.financialDetails.create,
        financialDetails
      )
      .pipe(
        tap((response) => {
          if (response.data) {
          }
        })
      );
  }

  createAdminFinancialDetails(
    financialDetails: FinancialDetails,
    stpMainId: number
  ): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.financialDetails.adminCreate}` + stpMainId,
      financialDetails
    );
  }

  updateFinancialDetails(financialDetails: FinancialDetails): Observable<any> {
    return this.httpClient
      .put<ServerResponse>(
        `${applicationUrls.financialDetails.update}`,
        financialDetails
      )
      .pipe(
        tap((res) => {
          if (res.data) {
            this.stpRegistrationService.updateFinancialDetails(res.data);
          }
        })
      );
  }

  updateAdminFinancialDetails(
    financialDetails: FinancialDetails,
    stpMainId: number
  ): Observable<any> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.financialDetails.adminUpdate}` + stpMainId,
      financialDetails
    );
  }

  //#endregion Financial Details

  //#region Management & Staff
  updateStpManagement(
    stpManagement: StpManagement,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient
      .put<ServerResponse>(
        `${applicationUrls.management.update}` + id,
        stpManagement
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.updatedStpManagement(
              response.data,
              response.data.id
            );
          }
        })
      );
  }

  updateAdminStpManagement(
    stpManagement: StpManagement,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.management.adminUpdate}` + id,
      stpManagement
    );
  }

  createStpManagement(
    stpManagement: StpManagement
  ): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.management.create}`,
        stpManagement
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.addStpManagement(response.data);
          }
        })
      );
  }

  createAdminStpManagement(
    stpManagement: StpManagement,
    stpMainId: number
  ): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.management.adminCreate}` + stpMainId,
      stpManagement
    );
  }

  //#endregion Management & Staff

  // #region Occupation specific tools region

  readStpOccupationTool(): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.tools.read}`)
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.setStpOccupationTools(response.data);
          }
        })
      );
  }

  // readStpOccupationList(): Observable<ServerResponse> {
  //   return (
  //     this.httpClient
  //       .get<ServerResponse>(`${applicationUrls.stpTrainer.readOccupation}`)
  //       // need to change the Url
  //       .pipe(
  //         tap((response) => {
  //           return response.data;
  //         })
  //       )
  //   );
  // }

  readStpOccupationToolsById(id: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.tools.readById + id}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((furniture: any) => { })
      );
  }
  updateStpOccupationTool(
    stpOccupationTool: StpOccupationTool,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient
      .put<ServerResponse>(
        `${applicationUrls.tools.update}` + id,
        stpOccupationTool
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.updatedStpOccupationTool(
              response.data,
              response.data.id
            );
          }
        })
      );
  }

  updateAdminStpOccupationTool(
    stpOccupationTool: StpOccupationTool,
    id: number | null
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.tools.adminUpdate}` + id,
      stpOccupationTool
    );
  }

  createStpOccupationTool(
    stpOccupationTool: StpOccupationTool
  ): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.tools.create}`,
        stpOccupationTool
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.addStpOccupationTool(response.data);
          }
        })
      );
  }

  createAdminStpOccupationTool(
    stpOccupationTool: StpOccupationTool,
    stpMainId: number
  ): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.tools.adminCreate}` + stpMainId,
      stpOccupationTool
    );
  }

  deleteStpOccupationTool(id: number): Observable<ServerResponse> {
    return this.httpClient
      .delete<ServerResponse>(`${applicationUrls.tools.delete}` + id)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        })
      );
  }

  // updateStpOccupationTool(
  //   stpOccupationTool: StpOccupationTool,
  //   id: number | null
  // ): Observable<ServerResponse> {
  //   return this.httpClient
  //     .put<ServerResponse>(
  //       `${applicationUrls.tools.update}` + id,
  //       stpOccupationTool
  //     )
  //     .pipe(
  //       tap((response) => {
  //         if (response.data) {
  //           this.stpRegistrationService.updatedStpOccupationTool(
  //             response.data,
  //             response.data.id
  //           );
  //         }
  //       })
  //     );
  // }

  //#endregion Occupation specific tools region

  //#region payment

  savePaymentinfo(formData: FormData): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(`${applicationUrls.payment.create}`, formData)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        })
      );
  }

  mailingPdf(file: FormData): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.certificate.sendingMailByStpMainId}`,
        file
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        })
      );
  }

  mailingBasicProfile(mailingDto: FormData): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.basicProfile.mailingAfterFinalSubmit}`,
        mailingDto
      );
  }

  readPaymentDetailsByStpMainId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.payment.readByStpMainId}` + id
    );
  }

  //#endregion payment by Fuad

  // readStpApplicationsList(): Observable<ServerResponse> {
  //   return (
  //     this.httpClient
  //       .get<ServerResponse>(`${applicationUrls.applications.read}`)
  //       // need to change the Url
  //       .pipe(
  //         tap((response) => {
  //           return response.data;
  //         })
  //       )
  //   );
  // }

  readStpApplicationsList(
    page: number,
    size?: number,
    stpMainSearchingDto?: StpMainSearchingDto,
    sortingKey?: string,
    sortingValue?: string
  ): Observable<ServerResponse> {

    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      stpApplicationId: (stpMainSearchingDto?.stpApplicationId ? stpMainSearchingDto?.stpApplicationId : null),
      stpName: (stpMainSearchingDto?.stpName ? stpMainSearchingDto?.stpName : null),
      stpOwnerShipStatusId: (stpMainSearchingDto?.stpOwnerShipStatusId ? stpMainSearchingDto?.stpOwnerShipStatusId : null),
      sysDistrictId: (stpMainSearchingDto?.sysDistrictId ? stpMainSearchingDto?.sysDistrictId : null),
      stpIsApproved: (stpMainSearchingDto?.stpIsApproved == true ? true : null),
      stpIsNotApproved: (stpMainSearchingDto?.stpIsNotApproved == true ? false : null),
      currectionNeeded: stpMainSearchingDto?.currectionNeeded,
      pendingStp : (stpMainSearchingDto?.pendingStp == true ? true: null),
      registrationNo: stpMainSearchingDto?.registrationNo,
      occupationName: (stpMainSearchingDto?.occupationName ? stpMainSearchingDto?.occupationName : null),
      occupationId: (stpMainSearchingDto?.occupationId ? stpMainSearchingDto?.occupationId : null),
      levelId: (stpMainSearchingDto?.levelId ? stpMainSearchingDto?.levelId : null),
      submissionStatusId: (stpMainSearchingDto?.submissionStatusId ? stpMainSearchingDto?.submissionStatusId : null),
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null
    };
    if (pageableRequestBodyDTO.stpIsApproved == true && pageableRequestBodyDTO.stpIsNotApproved == false) {
      pageableRequestBodyDTO.stpIsApproved = null;
      pageableRequestBodyDTO.stpIsNotApproved = null;
    }
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.applications.read}`,
      pageableRequestBodyDTO
    );
  }

  readFilteredStpApplicationsList(
    page: number,
    size?: number,
    countType?:string,
    sortingKey?: string,
    sortingValue?: string
  ): Observable<ServerResponse> {

    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      countType : countType? countType : null,
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null
    };

    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.applications.readFilteredStpApplicationsList}`,
      pageableRequestBodyDTO
    );
  }

  // Archived (previously approved) versions of the logged-in STP's application.
  getStpArchiveApplicationListForCurrentUser(): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.applications.getStpArchiveApplicationListForCurrentUser}`
    );
  }

  getStpApplicationListByUserId(
    page: number,
    size?: number,
    sortingKey?: string,
    sortingValue?: string,
    userId?: string,
    // STP-side search: applicationType 'new' | 'renewal' | 'reapply', searchText = application id or registration no
    filters?: { applicationType?: string | null; searchText?: string | null }
  ): Observable<ServerResponse> {
    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null,
      userId: Number(userId),
      applicationType: filters?.applicationType || null,
      stpApplicationId: this.searchText(filters?.searchText),
    };

    return this.httpClient.post<ServerResponse>(`${applicationUrls.applications.getStpApplicationListByUserId}`, pageableRequestBodyDTO);
  }

  reApplyStpApplication(stpMainId: number){
    return this.httpClient.get<ServerResponse>(`${applicationUrls.applications.reApplyStpApplication}` + stpMainId);
  }

  renewStpApplication(stpMainId: number){
    return this.httpClient.get<ServerResponse>(`${applicationUrls.applications.renewStpApplication}` + stpMainId);
  }

  getAllRegisteredStp(
    page: number,
    size?: number,
    stpMainSearchingDto?: StpMainSearchingDto,
    sortingKey?: string,
    sortingValue?: string
  ): Observable<ServerResponse> {

    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      stpApplicationId: (stpMainSearchingDto?.stpApplicationId ? stpMainSearchingDto?.stpApplicationId : null),
      stpName: (stpMainSearchingDto?.stpName ? stpMainSearchingDto?.stpName : null),
      stpOwnerShipStatusId: (stpMainSearchingDto?.stpOwnerShipStatusId ? stpMainSearchingDto?.stpOwnerShipStatusId : null),
      sysDistrictId: (stpMainSearchingDto?.sysDistrictId ? stpMainSearchingDto?.sysDistrictId : null),
      occupationId: (stpMainSearchingDto?.occupationId ? stpMainSearchingDto?.occupationId : null),
      levelId: (stpMainSearchingDto?.levelId ? stpMainSearchingDto?.levelId : null),
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null
    };

    return this.httpClient.post<ServerResponse>(`${applicationUrls.applications.getAllRegisteredStp}`, pageableRequestBodyDTO);
  }

  getAllRegisteredStpWithoutPagination(
    page: number,
    size?: number,
    stpMainSearchingDto?: StpMainSearchingDto,
    sortingKey?: string,
    sortingValue?: string
  ): Observable<ServerResponse> {

    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      stpApplicationId: (stpMainSearchingDto?.stpApplicationId ? stpMainSearchingDto?.stpApplicationId : null),
      stpName: (stpMainSearchingDto?.stpName ? stpMainSearchingDto?.stpName : null),
      stpOwnerShipStatusId: (stpMainSearchingDto?.stpOwnerShipStatusId ? stpMainSearchingDto?.stpOwnerShipStatusId : null),
      sysDistrictId: (stpMainSearchingDto?.sysDistrictId ? stpMainSearchingDto?.sysDistrictId : null),
      occupationId: (stpMainSearchingDto?.occupationId ? stpMainSearchingDto?.occupationId : null),
      levelId: (stpMainSearchingDto?.levelId ? stpMainSearchingDto?.levelId : null),
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null
    };

    return this.httpClient.post<ServerResponse>(`${applicationUrls.applications.getAllRegisteredStpWithoutPagination}`, pageableRequestBodyDTO);
  }

  getAllStpListViewExcelInfo(stpMainSearchingDto: StpMainSearchingDto): Observable<ServerResponse> {
    const pageableRequestBodyDTO = {
      stpName: (stpMainSearchingDto?.stpName ? stpMainSearchingDto?.stpName : null),
      registrationNo: stpMainSearchingDto?.registrationNo,
      stpOwnerShipStatusId: (stpMainSearchingDto?.stpOwnerShipStatusId ? stpMainSearchingDto?.stpOwnerShipStatusId : null),
      sysDistrictId: (stpMainSearchingDto?.sysDistrictId ? stpMainSearchingDto?.sysDistrictId : null),
      occupationName: (stpMainSearchingDto?.occupationName ? stpMainSearchingDto?.occupationName : null)
    };

    return this.httpClient.post<ServerResponse>(`${applicationUrls.applications.getAllStpListViewExcelInfo}`,pageableRequestBodyDTO);
  }

  initiateRollBackRequest(stpUserId: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.applications.rollBackRequest + '?stpUserId=' + stpUserId
        }`
      )
      .pipe(
        map((serverResponse: any) => {
          return serverResponse;
        })
      );
  }

  getAllUserDetailsInfo(stpMainSearchingDto: StpMainSearchingDto): Observable<ServerResponse> {
    const pageableRequestBodyDTO = {
      stpApplicationId: (stpMainSearchingDto?.stpApplicationId ? stpMainSearchingDto?.stpApplicationId : null),
      stpName: (stpMainSearchingDto?.stpName ? stpMainSearchingDto?.stpName : null),
      stpIsApproved: (stpMainSearchingDto?.stpIsApproved == true ? true : null),
      stpIsNotApproved: (stpMainSearchingDto?.stpIsNotApproved == true ? false : null),
      currectionNeeded: stpMainSearchingDto?.currectionNeeded,
      pendingStp: (stpMainSearchingDto?.pendingStp == true ? true: null),
      stpOwnerShipStatusId: (stpMainSearchingDto?.stpOwnerShipStatusId ? stpMainSearchingDto?.stpOwnerShipStatusId : null),
      sysDistrictId: (stpMainSearchingDto?.sysDistrictId ? stpMainSearchingDto?.sysDistrictId : null),
      occupationName: (stpMainSearchingDto?.occupationName ? stpMainSearchingDto?.occupationName : null),
      submissionStatusId: (stpMainSearchingDto?.submissionStatusId ? stpMainSearchingDto?.submissionStatusId : null)
    };
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.user.getAllUserDetailsInfo}`, pageableRequestBodyDTO
    );
  }

  readStpApplicationsbyId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.applications.readById}` + id
    );
  }

  readStpApplicationsForInspectionEdit(
    stpMainId: number,
    isReapplied?: boolean | null,
    isRenewed?: boolean | null
  ): Observable<ServerResponse> {
    const useRenewReapplyApi = isReapplied === true || isRenewed === true;
    return this.httpClient.get<ServerResponse>(
      useRenewReapplyApi
        ? `${applicationUrls.stpRenewReapplyInspection.readStpInfo}` + stpMainId
        : `${applicationUrls.applications.readById}` + stpMainId
    );
  }

  getPreviousStpAppInfoByStpMainId(id: number,applicationId: any): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.applications.getPreviousStpAppInfoByStpMainId}` + id+'/'+applicationId
    );
  }

  readStpApplicationsforInspectionbyId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.inspection.readById}` + id
    );
  }
  readStpMainbyId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.applications.readById}` + id
    );
  }

  readStpInfraByStpMainId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.physicalInfra.readById}` + id
    );
  }

  readStpFinancialFundsByStpMainId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.financialDetails.fundsById}` + id
    );
  }

  readStpFinancialIncomeByStpMainId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.financialDetails.incomeById}` + id
    );
  }

  readStpFinancialExpenseByStpMainId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.financialDetails.expenseById}` + id
    );
  }

  readBasicProfileById(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.applications.readByStpMainId}` + id
    );
  }

  //#region Unit (common portion with fuad vai)

  readSysUnitList(): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.unit.read}`)
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.setSysUnits(response.data);
          }
        })
      );
  }

  getSysUnitById(id: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.unit.readById}` + id)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((unit: any) => { })
      );
  }

  //#endregion Unit (common portion with fuad vai)

  //#region online payment
  initiatePaymentRequest(requestData: RequestData): Observable<any> {
    return this.httpClient
      .get<any>(
        `${applicationUrls.payment.createOnlinePayment}` + requestData.id
      )
      .pipe(
        map((serverResponse: any) => {
          return serverResponse;
        })
      );
  }

  initiateNewStpPaymentRequest(requestData: any): Observable<any> {
    return this.httpClient
      .post<any>(
        `${applicationUrls.payment.createNewStpOnlinePayment}`,
        requestData
      )
      .pipe(
        map((serverResponse: any) => {
          return serverResponse;
        })
      );
  }

  //#region online payment
  initiateRenewReapplyPaymentRequest(requestData: any): Observable<any> {
    return this.httpClient
      .post<any>(
        `${applicationUrls.payment.createRenewReapplyOnlinePayment}`,
        requestData
      )
      .pipe(
        map((serverResponse: any) => {
          return serverResponse;
        })
      );
  }

  stpCorrectionOnlinePayment(requestData: PaymentDto): Observable<any> {
    return this.httpClient.post<any>(`${applicationUrls.payment.stpCorrectionOnlinePaymentRequest}`, requestData)
      .pipe(
        map((serverResponse: any) => {
          return serverResponse;
        })
      );
  }
  //#endregion online payment

  //#region  otp verification
  getOtp(contactNumber: string): Observable<ServerResponse> {
    const apiKey = environment.smsConfig.secretKey;
    const headers = new HttpHeaders().set('X-API-KEY', apiKey);
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.otp.readContact + contactNumber}`, { headers })
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  // sendingPdf(userId: number, certificatePdf: any): Observable<ServerResponse> {
  //   return this.httpClient
  //     .get<ServerResponse>(
  //       `${
  //         applicationUrls.certificate.sendingMailByStpMainId +
  //         userId +
  //         certificatePdf
  //       }`
  //     )
  //     .pipe(
  //       map((serverResponse: ServerResponse) => {
  //         return serverResponse;
  //       })
  //     );
  // }
  //#endregion

  getVerifiedOtp(
    otpNumber: string,
    contactNumber: string,
  ): Observable<ServerResponse> {
    const params = new HttpParams()
      .append('mobileNo', `${contactNumber}`)
      .append('otp', `${otpNumber}`);
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.otp.readOtp}`, {
        params,
      })
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  getVerifiedOtpToEmail(
    otpNumber: string,
    email: string,
  ): Observable<ServerResponse> {
    const params = new HttpParams()
      .append('email', `${email}`)
      .append('otp', `${otpNumber}`);
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.otp.readOtpToEmail}`, {
        params,
      })
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  //#endregion otp verification

  //#region  get all user details info


  getUserApplicationStatusInfo(): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.user.getUserApplicationStatusInfo}`
    );
  }

  //#endregion get user information by id

  getlUserInfoById(userId: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.user.getUserById}?userId=` + userId
    );
  }

  //#region user info by id
  stpMainIdByUserId(requestData: RequestData): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.stpFullInformation.userFullInformation}` +
        requestData.id
      )
      .pipe(
        map((serverResponse: any) => {
          return serverResponse;
        })
      );
  }
  //#endregion

  //#region Update STP Main
  updateStpMain(
    stpNameUpdate: STpNameUpdateRequest
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.applications.stpNameUpdate}`,
      stpNameUpdate
    );
  }

  updateStpOrganizationDetails(
    stpNameUpdate: StpOrganizationAddressUpdateRequest
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.applications.updateStpOrganizationDetails}`,
      stpNameUpdate
    );
  }

  getStpOrganizationDetails(
    stpMainId: number
  ): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.applications.getStpOrganizationDetails}?stpMainId=` + stpMainId
    );
  }

  updateStpApproval(userId: number, approvalDateFromAdmin: any): Observable<ServerResponse> {
    const params = new HttpParams()
    .append('userId', `${userId}`)
    .append('approvalDateFromAdmin', `${approvalDateFromAdmin.toString()}`);
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.applications.stpApprovalUpdate}`,
      params
    );
  }
  //#endregion Update STP Main

  //#region  Get Certificate Information By StpMain Id

  getCertificateInformationByStpMainId(id: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.certificate.readByStpMainInfoByIdUsingQrCode}?id=${id}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  // getCertificateInformation(id: number): Observable<any> {
  //   return this.httpClient
  //     .get<ServerResponse>(
  //       `${applicationUrls.certificate.readByStpMainId + '/' + id}`
  //     )
  //     .pipe(
  //       map((serverResponse: ServerResponse) => {
  //         return serverResponse;
  //       })
  //     );
  // }

  // getCertificateInformation(id: number): Observable<any> {
  //   return this.httpClient
  //     .get<Blob>(
  //       `${applicationUrls.certificate.downloadCertificateByStpMainId + '/' + id}`,
  //       {
  //         observe: 'response',
  //         responseType: 'blob' as 'json',
  //       }
  //     )
  // }

  getCertificateInformation(id: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.certificate.downloadCertificateByStpMainId + '/' + id}`
      )
  }

  getOccupationLevelDetails(tamMainId: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.occupationLevel.registrationOccupationandLevelDetailsById + '/' + tamMainId}`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  filteringSTPApplication(
    stpFilteringRequestData: StpFilteringRequestData
  ): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.applications.filteredStpApplication}` +
        stpFilteringRequestData
      )
      .pipe(
        map((serverResponse: any) => {
          return serverResponse;
        })
      );
  }

  //#endregion Get Certificate Information By StpMain Id

  //#region STP name Unique check by Admin

  checkStpNameExist(stpName: string): Observable<ServerResponse> {
    const params = new HttpParams().append('stpName', `${stpName}`);
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.userVerification.checkStpNameExist}`,
        {
          params,
        }
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  //#endregion STP name Unique check by Admin

  //#region Excel data save for StpOccupationTool

  saveExcelData(
    stpOccupationTool: StpOccupationTool[]
  ): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.tools.saveExcelData}`,
        stpOccupationTool
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.addStpOccupationTool(response.data[0]);
          }
        })
      );
  }

  //#endregion Excel data save for StpOccupationTool

  //#region check is application submitted

  isApplicationSubmitted(userId: any): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.actionHistory.isApplicationSubmitted +
        '?userId=' +
        userId
        }`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  //#endregion check is application submitted

  //#region check is application submitted

  applicationSubmit(userId: any): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.actionHistory.applicationSubmit + '?userId=' + userId
        }`
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  //#endregion check is application submitted

  //#region Excel data save for StpManagement

  saveExcelStaffData(
    stpManagement: StpManagement[]
  ): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.management.saveExcelData}`,
        stpManagement
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.addStpManagement(response.data);
          }
        })
      );
  }

  //#endregion Excel data save for StpManagement

  //#region Excel data save for stpTrainer

  saveExcelTrainerData(stpTrainer: StpTrainer[]): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.stpTrainer.saveExcelData}`,
        stpTrainer
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.setStpTrainersForExcel(response.data);
          }
        })
      );
  }

  //#endregion Excel data save for stpTrainer

  //#region Excel data save for Furniture

  saveExcelFurnitureData(furniture: Furniture[]): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.furniture.saveExcelData}`,
        furniture
      )
      .pipe(
        tap((response) => {
          if (response.data) {
            this.stpRegistrationService.setFurnitureForExcel(response.data);
          }
        })
      );
  }

  //#endregion Excel data save for Furniture


  //#region temporary reject stp user
  temporaryRejectStpUser(approveRejectStpUserDto: TempApproveRejectStpUserDto): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.applications.approveRejectStpUser}`,
      approveRejectStpUserDto
    );
  }

  // every correction request of an STP (new application, renewal or reapply), newest first
  getCorrectionHistory(stpMainId: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(`${applicationUrls.applications.correctionHistory}` + stpMainId);
  }

  // renewal / reapply: accept or request correction on the application copy (the live STP is not changed)
  reviewRenewReapplyApplication(approveRejectStpUserDto: TempApproveRejectStpUserDto): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.applications.reviewRenewReapplyApplication}`,
      approveRejectStpUserDto
    );
  }
  //#endregion temporary reject stp user


  //#region read stp main info
  readStpMains(): Observable<StpMain[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.applications.readStpMain}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }
  //#endregion

  readStpBasicProfilebyId(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.basicProfile.readBasicProfileById}` + id
    );
  }

  readAdminBasicProfileById(id: number): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.basicProfile.readAdminBasicProfileById}` + id
    );
  }

  // data: the stpMainIds (of those given) with a renewal / re-apply in progress
  getPendingRenewReapplyStpMainIds(stpMainIds: number[]): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.stpRenewReapplyInspection.getPendingRenewReapplyStpMainIds}`,
      stpMainIds
    );
  }

  // data.hasPendingRenewOrReapplyApplication: a renewal / re-apply of the STP is in progress
  getRenewReapplyApplicationStatus(stpMainId: number): Observable<ServerResponse> {
    const params = new HttpParams().append('stpMainId', `${stpMainId}`);
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.stpRenewReapplyInspection.getRenewReapplyApplicationStatus}`,
      { params }
    );
  }


  addMinistry(ministry: Ministry) {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.ministry.saveMinistry}`,
        ministry
      )
  }

  getAgencyByMinistryId(id: number) {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.ministry.getMinistryById}/`+ id
      )
  }

  getMinistryList(ministry: Ministry) {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.ministry.getMinistryList}`,
        ministry
      )
  }

  getIscOfficerList(inspectorOfficer1: InspectorOfficer1) {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.basicProfile.readInspectionOfficers}`,
        inspectorOfficer1
      )
  }

  getAgencyList(agency: Agency) {
    agency.pageNumber -=1;
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.agency.getAgencyList}`,
        agency
      )
  }

  getAllStpMinistries() {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.basicProfile.readStpMinistry}`
      )
  }

  addAgency(agency: Agency) {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.agency.saveAgency}`,
        agency
      )
  }

  getAgencyById(id : number) {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.agency.getAgencyById}/`+id
      )
  }

  deleteAgency(id: number | undefined) {
    return this.httpClient
    .delete<ServerResponse>(
      `${applicationUrls.agency.deleteAgency}/`+id
    )
  }

  deleteMinistry(id: number | undefined) {
    return this.httpClient
    .delete<ServerResponse>(
      `${applicationUrls.ministry.deleteMinistry}/`+id
    )
  }


  //#region read approved stp register count
  readApprovedStpRegisterCount(): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.landingPageCounter.readApprovedStpRegisterCount}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        })
      );
  }
  //#endregion

  //#region read approved stp courses count
  readApprovedStpCoursesCount(): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.landingPageCounter.readApprovedStpCoursesCount}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        })
      );
  }
  //#endregion
  //#region read approved stp center count
  readApprovedStpCenterCount(): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.landingPageCounter.readApprovedStpCenterCount}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        })
      );
  }
  //#endregion

  getInspectionOfficerById(id : number) {
    return this.httpClient.get<ServerResponse>(`${applicationUrls.inspection.inspectionOfficer.getInspectionOfficerById}/` + id)
  }

  saveInspectionOfficer(inspectionOfficer: InspectionOfficer) {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.inspection.inspectionOfficer.saveInspectionOfficer}`, inspectionOfficer)
  }

  //#region check existing contact number to add representative
  checkContactNumberExist(id: number, phone: string): Observable<ServerResponse> {
    const params = new HttpParams().append('id', `${id}`).append('phone', `${phone}`);

    return this.httpClient.get<ServerResponse>(`${applicationUrls.inspection.checkInspectionOfficerByPhone}`, {params})
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  //#endregion
  sendingOTPtoMail(email: string, userId:any ): Observable<any> {
    const params = new HttpParams().append('email',  `${email}` ).append('userId',  `${userId}`) ;
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.otp.sendingOTPtoMail}`,
        {}, // Empty body
        { params } // Attach query parameters
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse.data || null; // Return null if data is missing
        })
      );
  }

  getSetupInfo(){
    return this.httpClient.get<ServerResponse>(`${applicationUrls.setup.getSetupInfo}`);
  }
  getRplIndvSetupInfo(){
    return this.httpClient.get<ServerResponse>(`${applicationUrls.setup.getRplIndvSetupInfo}`);
  }

  saveSetupInfo(setup: any) {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.setup.saveSetupInfo}`, setup)
  }

  saveRplIndvSetupInfo(setup: any) {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.setup.saveRplIndvSetupInfo}`, setup)
  }

  // data: { currentDays, defaultDays, history: [{ id, days, remarks, isActive, startDate, endDate, createdAt }] }
  getReapplyCooldownInfo() {
    return this.httpClient.get<ServerResponse>(`${applicationUrls.setup.getReapplyCooldownInfo}`);
  }

  // { days, startDate: 'yyyy-MM-dd' | null, remarks }
  saveReapplyCooldownInfo(payload: any) {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.setup.saveReapplyCooldownInfo}`, payload);
  }

  getCorrectionRequestInfoByStpMainId(stpMainId: number){
    return this.httpClient.get<ServerResponse>(`${applicationUrls.stpCorrectionRequest.getCorrectionRequestInfoByStpMainId}` + stpMainId);
  }

  saveCorrectionRequestInfo(correctionRequest: any) {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.stpCorrectionRequest.saveCorrectionRequestInfo}`, correctionRequest)
  }

  submitCorrectionRequestInfo(correctionRequest: any) {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.stpCorrectionRequest.submitCorrectionRequestInfo}`, correctionRequest)
  }

  getAllStpCorrectionRequestList(
    page: number,
    size?: number,
    sortingKey?: string,
    sortingValue?: string
  ): Observable<ServerResponse> {
    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null
    };

    return this.httpClient.post<ServerResponse>(`${applicationUrls.stpCorrectionRequest.getAllStpCorrectionRequestList}`, pageableRequestBodyDTO);
  }

  getSubmittedStpCorrectionRequestListByUserId(
    page: number,
    size?: number,
    sortingKey?: string,
    sortingValue?: string,
    userId?: string | number
  ): Observable<ServerResponse> {
    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null,
      userId: Number(userId)
    };

    return this.httpClient.post<ServerResponse>(`${applicationUrls.stpCorrectionRequest.getSubmittedStpCorrectionRequestListByUserId}`, pageableRequestBodyDTO);
  }

  getCorrectionRequestInfoById(correctionRequestId: number){
    return this.httpClient.get<ServerResponse>(`${applicationUrls.stpCorrectionRequest.getCorrectionRequestInfoById}` + correctionRequestId);
  }

  submitCorrectionRequestApprovalDecision(correctionRequest: any) {
    return this.httpClient.post<ServerResponse>(`${applicationUrls.stpCorrectionRequest.submitCorrectionRequestApprovalDecision}`, correctionRequest)
  }


  getPreviousStpApplication(
    page: number,
    size?: number,
    stpMainSearchingDto?: StpMainSearchingDto,
    sortingKey?: string,
    sortingValue?: string
  ): Observable<ServerResponse> {

    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      stpApplicationId: (stpMainSearchingDto?.stpApplicationId ? stpMainSearchingDto?.stpApplicationId : null),
      stpName: (stpMainSearchingDto?.stpName ? stpMainSearchingDto?.stpName : null),
      stpOwnerShipStatusId: (stpMainSearchingDto?.stpOwnerShipStatusId ? stpMainSearchingDto?.stpOwnerShipStatusId : null),
      sysDistrictId: (stpMainSearchingDto?.sysDistrictId ? stpMainSearchingDto?.sysDistrictId : null),
      stpIsApproved: (stpMainSearchingDto?.stpIsApproved == true ? true : null),
      stpIsNotApproved: (stpMainSearchingDto?.stpIsNotApproved == true ? false : null),
      currectionNeeded: stpMainSearchingDto?.currectionNeeded,
      pendingStp : (stpMainSearchingDto?.pendingStp == true ? true: null),
      registrationNo: stpMainSearchingDto?.registrationNo,
      occupationName: (stpMainSearchingDto?.occupationName ? stpMainSearchingDto?.occupationName : null),
      occupationId: (stpMainSearchingDto?.occupationId ? stpMainSearchingDto?.occupationId : null),
      levelId: (stpMainSearchingDto?.levelId ? stpMainSearchingDto?.levelId : null),
      submissionStatusId: (stpMainSearchingDto?.submissionStatusId ? stpMainSearchingDto?.submissionStatusId : null),
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null
    };
    if (pageableRequestBodyDTO.stpIsApproved == true && pageableRequestBodyDTO.stpIsNotApproved == false) {
      pageableRequestBodyDTO.stpIsApproved = null;
      pageableRequestBodyDTO.stpIsNotApproved = null;
    }
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.applications.getPreviousStpApplications}`,
      pageableRequestBodyDTO
    );
  }

  // search text for the renewal / reapply / archive lists: trimmed, and blank = no filter
  private searchText(value: any): string | null {
    return typeof value === 'string' && value.trim() ? value.trim() : null;
  }

   readRenewalStpApplicationsList(
  page: number,
  size?: number,
  stpMainSearchingDto?: StpMainSearchingDto,
  sortingKey?: string,
  sortingValue?: string,
  assignedOnly = false
): Observable<ServerResponse> {

  const pageableRequestBodyDTO = {
    page: page - 1,
    size: size ?? null,

    stpApplicationId: this.searchText(stpMainSearchingDto?.stpApplicationId),
    stpName: this.searchText(stpMainSearchingDto?.stpName),
    stpOwnerShipStatusId: stpMainSearchingDto?.stpOwnerShipStatusId ?? null,
    sysDistrictId: stpMainSearchingDto?.sysDistrictId ?? null,

    stpIsApproved: stpMainSearchingDto?.stpIsApproved === true ? true : null,
    stpIsNotApproved: stpMainSearchingDto?.stpIsNotApproved === true ? false : null,

    currectionNeeded: stpMainSearchingDto?.currectionNeeded ?? null,
    pendingStp: stpMainSearchingDto?.pendingStp === true ? true : null,

    registrationNo: this.searchText(stpMainSearchingDto?.registrationNo),
    occupationName: stpMainSearchingDto?.occupationName ?? null,
    occupationId: stpMainSearchingDto?.occupationId ?? null,
    levelId: stpMainSearchingDto?.levelId ?? null,
    submissionStatusId: stpMainSearchingDto?.submissionStatusId ?? null,

    sortingKey: sortingKey ?? null,
    sortingValue: sortingValue ?? null
  };

  // Reset both if both selected
  if (
    pageableRequestBodyDTO.stpIsApproved === true &&
    pageableRequestBodyDTO.stpIsNotApproved === false
  ) {
    pageableRequestBodyDTO.stpIsApproved = null;
    pageableRequestBodyDTO.stpIsNotApproved = null;
  }

  return this.httpClient.post<ServerResponse>(
    `${assignedOnly ? applicationUrls.applications.readAssignedRenewalStpApplication : applicationUrls.applications.readRenewalStpApplication}`,
    pageableRequestBodyDTO
  );
}

readReapplyStpApplicationsList(
  page: number,
  size?: number,
  stpMainSearchingDto?: StpMainSearchingDto,
  sortingKey?: string,
  sortingValue?: string,
  assignedOnly = false
): Observable<ServerResponse> {

  const pageableRequestBodyDTO = {
    page: page - 1,
    size: size ?? null,

    stpApplicationId: this.searchText(stpMainSearchingDto?.stpApplicationId),
    stpName: this.searchText(stpMainSearchingDto?.stpName),
    stpOwnerShipStatusId: stpMainSearchingDto?.stpOwnerShipStatusId ?? null,
    sysDistrictId: stpMainSearchingDto?.sysDistrictId ?? null,

    stpIsApproved: stpMainSearchingDto?.stpIsApproved === true ? true : null,
    stpIsNotApproved: stpMainSearchingDto?.stpIsNotApproved === true ? false : null,

    currectionNeeded: stpMainSearchingDto?.currectionNeeded ?? null,
    pendingStp: stpMainSearchingDto?.pendingStp === true ? true : null,

    registrationNo: this.searchText(stpMainSearchingDto?.registrationNo),
    occupationName: stpMainSearchingDto?.occupationName ?? null,
    occupationId: stpMainSearchingDto?.occupationId ?? null,
    levelId: stpMainSearchingDto?.levelId ?? null,
    submissionStatusId: stpMainSearchingDto?.submissionStatusId ?? null,

    sortingKey: sortingKey ?? null,
    sortingValue: sortingValue ?? null
  };

  // Reset both if both selected
  if (
    pageableRequestBodyDTO.stpIsApproved === true &&
    pageableRequestBodyDTO.stpIsNotApproved === false
  ) {
    pageableRequestBodyDTO.stpIsApproved = null;
    pageableRequestBodyDTO.stpIsNotApproved = null;
  }

  return this.httpClient.post<ServerResponse>(
    `${assignedOnly ? applicationUrls.applications.readAssignedReapplyStpApplication : applicationUrls.applications.readReapplyStpApplication}`,
    pageableRequestBodyDTO
  );
}

readArchiveStpApplicationsList(
  page: number,
  size?: number,
  stpMainSearchingDto?: StpMainSearchingDto,
  sortingKey?: string,
  sortingValue?: string
): Observable<ServerResponse> {

  const pageableRequestBodyDTO = {
    page: page - 1,
    size: size ?? null,

    stpApplicationId: this.searchText(stpMainSearchingDto?.stpApplicationId),
    stpName: this.searchText(stpMainSearchingDto?.stpName),
    stpOwnerShipStatusId: stpMainSearchingDto?.stpOwnerShipStatusId ?? null,
    sysDistrictId: stpMainSearchingDto?.sysDistrictId ?? null,

    registrationNo: this.searchText(stpMainSearchingDto?.registrationNo),
    occupationName: stpMainSearchingDto?.occupationName ?? null,

    sortingKey: sortingKey ?? null,
    sortingValue: sortingValue ?? null
  };

  return this.httpClient.post<ServerResponse>(
    `${applicationUrls.applications.readArchiveStpApplication}`,
    pageableRequestBodyDTO
  );
}
}
